var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { attrs: { id: "application-form-common-fields" } }, [
    _c("input", {
      attrs: {
        fieldValue: _vm.companyName,
        type: "hidden",
        fieldTitle: "機構名稱",
        fieldname: _vm.asCompany ? "company" : "vendor",
      },
    }),
    _vm._v(" "),
    _c("input", {
      attrs: {
        fieldValue: _vm.from,
        type: "hidden",
        fieldTitle: "Platform",
        fieldname: "platform",
        fieldType: "text",
      },
    }),
    _vm._v(" "),
    _c("input", {
      attrs: {
        fieldValue: _vm.companyId,
        type: "hidden",
        fieldTitle: "機構ID",
        fieldname: _vm.asCompany ? "companyId" : "vendorId",
        fieldType: "companyId",
      },
    }),
    _vm._v(" "),
    _c("input", {
      attrs: {
        fieldValue: _vm.vendorEmail,
        type: "hidden",
        fieldTitle: "vendorEmail",
        fieldname: "vendorEmail",
        fieldType: "vendorEmail",
      },
    }),
    _vm._v(" "),
    _c("input", {
      attrs: {
        fieldValue: _vm.vendorMobile,
        type: "hidden",
        fieldTitle: "vendorMobile",
        fieldname: "vendorMobile",
        fieldType: "vendorMobile",
      },
    }),
    _vm._v(" "),
    _c("input", {
      attrs: {
        fieldValue: "1",
        type: "hidden",
        fieldTitle: "isApplicationForm",
        fieldname: "isApplicationForm",
        fieldType: "isApplicationForm",
      },
    }),
    _vm._v(" "),
    _c("input", {
      attrs: {
        fieldValue: _vm.productId,
        type: "hidden",
        fieldTitle: "productId",
        fieldname: "productId",
        fieldType: "productId",
      },
    }),
    _vm._v(" "),
    _c("input", {
      attrs: {
        fieldValue: _vm.productType,
        type: "hidden",
        fieldTitle: "productType",
        fieldname: "productType",
        fieldType: "productType",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }